// Remove circular dependency - use type assertion instead
import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import pkg from "../../package.json";

const DEFAULT_API_BASE_URL =
  "https://fidoapi-azuredev-dev.azurewebsites.net/v1";
const API_BASE_URL = import.meta.env.VITE_API || DEFAULT_API_BASE_URL;
const GIS_API_BASE_URL = import.meta.env.VITE_GIS_API || DEFAULT_API_BASE_URL;

const setBaseHeaders = (headers: Headers) => {
  headers.set("X-SOURCE", "cms");
  headers.set("X-Portal-Version", pkg.version);
  return headers;
};

type StateWithAuth = {
  auth: {
    token: string;
    azureToken: string;
  };
};

const PUBLIC_PORTAL_ENDPOINTS = new Set([
  "validateInvitationToken",
  "acceptInvitation"
]);

export const gisApiBaseQuery = fetchBaseQuery({
  baseUrl: GIS_API_BASE_URL,
  credentials: "include",
  prepareHeaders: (headers, { getState }) => {
    const state = getState() as StateWithAuth;
    const token = state.auth.token;
    const azureToken = state.auth.azureToken;

    setBaseHeaders(headers);
    if (token) {
      headers.set("user-token", `${token}`);
    }
    if (azureToken) {
      headers.set("Authorization", `Bearer ${azureToken}`);
    }

    return headers;
  }
});

export const apiBaseQuery = fetchBaseQuery({
  baseUrl: API_BASE_URL,
  credentials: "include",
  prepareHeaders: (headers, { getState, endpoint }) => {
    const state = getState() as StateWithAuth;
    const token = state.auth.token;

    setBaseHeaders(headers);
    if (!PUBLIC_PORTAL_ENDPOINTS.has(endpoint) && token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  }
});

export const authBaseQuery = fetchBaseQuery({
  baseUrl: API_BASE_URL,
  credentials: "include",
  prepareHeaders(headers) {
    setBaseHeaders(headers);
    return headers;
  }
});

export const aiAssistantBaseQuery = fetchBaseQuery({
  baseUrl: API_BASE_URL,
  credentials: "include",
  prepareHeaders: (headers, { getState }) => {
    const state = getState() as StateWithAuth;
    const token = state.auth.token;

    setBaseHeaders(headers);
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  }
});

export const genericFetchQuery = fetchBaseQuery();
